import {
  Col,
  Descriptions,
  DescriptionsProps,
  Popconfirm,
  Row,
  Space,
} from "antd";
import { DocumentTemplate } from "@rumble-it/common-lib/types/models/DocumentTemplate.interface";
import { UseMutationResult } from "@tanstack/react-query";
import { responsiveLabelStyle } from "@/theme/adminTheme";
import DocumentTemplatePreviewIframe from "./DocumentTemplatePreviewIframe";
import { DeleteOutlined } from "@ant-design/icons";
import { Button, Card } from "@rumbledirect/ui";

interface DocumentTemplateDetailCardProps {
  documentTemplate: DocumentTemplate | undefined;
  isLoading?: boolean;
  deleteMutation?: UseMutationResult<null, Error, void, unknown>;
}

export const DocumentTemplateDetailCard = ({
  documentTemplate,
  isLoading,
  deleteMutation,
}: DocumentTemplateDetailCardProps) => {
  const items: DescriptionsProps["items"] = [
    {
      label: "Titel",
      children: documentTemplate?.title,
    },
    {
      label: "Taal",
      children: documentTemplate?.language,
    },
    {
      label: "Type",
      children: documentTemplate?.type,
    },
    {
      label: "Versie",
      children: documentTemplate?.version,
    },
  ].filter((item) => item.children != null && item.children !== "");

  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <Card
          loading={isLoading}
          className="w-full"
          title="Document template"
          extra={
            <Space>
              <Popconfirm
                title="Document template verwijderen"
                description="Weet je zeker dat je deze document template wilt verwijderen?"
                onConfirm={() => deleteMutation?.mutate()}
                okText="Ja"
                cancelText="Nee"
              >
                <Button
                  loading={deleteMutation?.isPending}
                  danger
                  icon={<DeleteOutlined />}
                />
              </Popconfirm>
            </Space>
          }
        >
          {/* Using Descriptions to display the document template details */}
          <Descriptions
            layout="horizontal"
            bordered
            column={1}
            items={items}
            size="small"
            labelStyle={responsiveLabelStyle()}
          />
        </Card>
      </Col>

      <Col span={12}>
        {documentTemplate && documentTemplate.html ? (
          <DocumentTemplatePreviewIframe
            title="Preview document"
            html={documentTemplate.html}
          />
        ) : null}
      </Col>
    </Row>
  );
};
